import { action, observable } from 'mobx';
import { Entity, Updatable } from '../../../..';

export default class CourseItemTestAnswer extends Entity {
    constructor(answer?: Partial<CourseItemTestAnswer>) {
        super(answer);
        if (answer) this.update(answer);
    }
    @observable answer: string;
    @observable isCorrect: boolean;
    @observable position: number;

    @action
    update(answer: Partial<CourseItemTestAnswer>) {
        super.update(answer);
    }

    clone(): CourseItemTestAnswer {
        return new CourseItemTestAnswer({ ...this });
    }
}